import AddIntake from "../../Components/Modals/AddIntake";
import AddLevel from "../../Components/Modals/AddLevel";
import Table from "../../Components/Table";
import { deleteIntakeById, deleteLevelById, getAllLevelWithCount } from "../../Services/MasterService";

const Level = () => {
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Type",
            value: "type"
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddLevel data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllLevelWithCount}
            columns={columns}
            title={"Level Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteLevelById}
        />
    );
};

export default Level;